import React, { useState } from 'react';
import { useAppContext } from '../AppContext';

import { useTranslation } from "react-i18next";
import DatePicker from 'react-datepicker'
import moment from 'moment';
import mainAxios from '../services/mainAxios';

const SendNotification = () => {
    
    const {t} = useTranslation('translations');
    const {user: [user,], socketRef: [socketRef,]} = useAppContext()
    const [state,setState]=useState({
        startDate:null,
        endDate:null,
        message:""
    })

    const sendNotification = () => {
        const { message,startDate, endDate } = state
        mainAxios.post("/notifications/save",
        {text:message,startDate,endDate},
        )
        .then(res=>{
            if(res){
                console.log({res})
            }
        })
    };

    const handleChange=(key,value)=>{
        setState((state)=>({
            ...state,
            [key]:value
        }))
    }

    const refreshUsersPage=()=>{
        if(socketRef){
            socketRef.send('/topic/refresh',{}, JSON.stringify({
                name: user.username,
                message:"Refresh"
            }));
        }
    }
    return (
        <div className="row">
            <div className="col-lg-8 col-md-10 col-12 mx-auto">
                <div className="card border-0 shadow mb-3 mt-3">
                    <div className="card-header border-0">
                        <h3 className="mb-0">{t('notification.send')}</h3>
                    </div>
                    <div className="card-body"> 
                        <button 
                            className="btn btn-primary"
                            onClick={refreshUsersPage}>
                            Refresh Users Page
                        </button>
                        <div className="row my-4">
                            <div className="col-md-4">
                                <label>
                                    Start Date
                                </label>
                                <DatePicker 
                                    type="date"
                                    selected={state?.startDate ? new Date(state?.startDate) : ""} 
                                    onChange={date => handleChange("startDate", date?  moment(date).format('YYYY-MM-DDTHH:mm:ss'):"")}
                                    dateFormat="dd/MM/yyyy HH:mm"
                                    showTimeSelect
                                    className={`form-control required tip`}
                                    timeFormat="HH:mm"
                                    />
                            </div>
                            <div className="col-md-4">
                                <label>
                                    End Date
                                </label>
                                <DatePicker 
                                    selected={state?.endDate ? new Date(state?.endDate) : ""} 
                                    onChange={date => handleChange("endDate", date?  moment(date).format('YYYY-MM-DDTHH:mm:ss'):"")}
                                    dateFormat="dd/MM/yyyy HH:mm"
                                    showTimeSelect
                                    className={`form-control required tip`}
                                    timeFormat="HH:mm"
                                    />
                            </div>

                            <div className="col-3">
                                <label htmlFor=""></label>
                            </div>
                        </div>
                        <h3>Message</h3>                       
                        <textarea 
                            className="form-control mb-3"
                            value={state?.message ??""}
                            onChange={(e) => handleChange("message",e.target.value)}
                            rows="10">
                        </textarea> 
                        <button 
                            className="btn btn-primary"
                            onClick={sendNotification}>
                            {t('invoice.send')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SendNotification